import { Menu, squareBlockCSS } from '@braskai/ui-kit';

import { Box, ButtonBase, css, styled } from '@mui/material';

export const SMenu = styled(Menu)(
  () => css`
    width: 100%;

    & > div:first-of-type {
      width: 100%;
    }
  `,
);

export const SChevronIcon = styled(Box)(
  () => css`
    ${squareBlockCSS(20)};
    margin-left: auto;
    transition: transform 0.2s;

    svg {
      transition: color 0.2s;
    }
  `,
);

export const SContainer = styled(ButtonBase)(
  ({ theme }) => css`
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    padding: 10px 12px;
    box-shadow: 0 0 0 1px ${theme.palette.grey[200]};
    border-radius: 10px;
    max-height: 44px;

    ${theme.breakpoints.up('tablet')} {
      padding: 2px 10px;
      border-radius: 0;
      box-shadow: none;
      max-height: 100%;
    }
  `,
);
